import React from "react";
import { LogOut } from "lucide-react";
import { useDark } from "../Universal/useNavTheme";
import { usePopup } from "../contexts/PopupContext";

const PopUpLogOut = () => {
  const dark = useDark();
  const { setIsPopUpOpen } = usePopup();

  function userLogout() {
    try {
      localStorage.setItem("user", "");
      window.location.href = "/login";
    } catch (e) {
      console.log(e);
    }
  }

  return (
    <div className="relative">
      {/* Outer ambient glow — token-based, no hardcoded rgba */}
      <div
        aria-hidden
        className="pointer-events-none absolute -inset-6 -z-10 rounded-3xl bg-[radial-gradient(ellipse_at_center,var(--tw-gradient-stops))] from-velBlue/20 to-transparent opacity-70 blur-2xl transition-opacity duration-300"
      />

      <div
        role="dialog"
        aria-labelledby="logout-title"
        className="w-[min(92vw,440px)] rounded-lg border border-surfaceBorder bg-surface/80 backdrop-blur-md shadow-login-panel font-poppins font-normal transition-shadow duration-300 focus-within:shadow-login-panel-glow"
      >
        <div className="space-y-4 px-6 py-6">
          <div className="flex items-center gap-2">
            <LogOut className="h-5 w-5 text-velBlue" aria-hidden />
            <h3 id="logout-title" className="text-sm font-medium text-mainText">
              Sign out?
            </h3>
          </div>

          <p className="text-sm font-normal text-mutedText">
            You'll need to sign in again to continue.
          </p>

          <div className="flex justify-end gap-2">
            <button
              onClick={() => setIsPopUpOpen(false)}
              className="rounded-lg border border-btnBorder bg-transparent px-4 py-2.5 text-sm font-normal text-mainText outline-none ring-inputFocus/60 transition hover:bg-btnHover focus-visible:ring-2 cursor-pointer"
            >
              Cancel
            </button>

            <button
              onClick={userLogout}
              className="rounded-lg border border-logoutColor/40 bg-logoutColor/10 px-4 py-2.5 text-sm font-normal text-logoutColor outline-none ring-logoutColor/60 transition hover:bg-logoutColor/20 focus-visible:ring-2 cursor-pointer"
            >
              <span className="flex items-center gap-2">
                <LogOut className="h-4 w-4" aria-hidden />
                Sign out
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopUpLogOut;
